import React, { useState } from "react";
import { Badge, Col, Row } from "react-bootstrap";
import { CommonButton, CommonInput, CommonSelect } from "../Input";
import DataTable from "../table/DataTable";
import RefundInformationModal from "./RefundInformationModal";

const RefundsList = () => {
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedRefund, setSelectedRefund] = useState(null);

  const [filters, setFilters] = useState({
    transactionId: "",
    bulkId: "",
    paymentMethod: null,
    receivingMethod: null,
  });

  const initialData = [
    {
      id: "1",
      displayDate: "12/12/2025",
      time: "10:38:06",
      transactionId: "100005322",
      bulkId: "-",
      senderName: "QC",
      senderType: "Organization",
      sendAmount: "500 USD",
      receivingMethod: "Bank Transfer",
      paymentMethod: "Cash",
      status: "Refunding",
      statusValue: "refunding",
    },
  ];

  const [displayData, setDisplayData] = useState(initialData);

  const handleFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
  };

  const handleSearch = () => {
    let filtered = initialData.filter((item) => {
      const matchTransaction =
        !filters.transactionId ||
        item.transactionId
          .toLowerCase()
          .includes(filters.transactionId.toLowerCase());
      const matchBulk =
        !filters.bulkId ||
        item.bulkId.toLowerCase().includes(filters.bulkId.toLowerCase());
      const matchPayment =
        !filters.paymentMethod ||
        item.paymentMethod.toLowerCase() ===
          filters.paymentMethod.label.toLowerCase();
      const matchReceiving =
        !filters.receivingMethod ||
        item.receivingMethod.toLowerCase() ===
          filters.receivingMethod.label.toLowerCase();
      return matchTransaction && matchBulk && matchPayment && matchReceiving;
    });
    setDisplayData(filtered);
  };

  const handleReset = () => {
    setFilters({
      transactionId: "",
      bulkId: "",
      paymentMethod: null,
      receivingMethod: null,
    });
    setDisplayData(initialData);
  };

  const columns = [
    {
      label: "Date & Time",
      key: "createdDate",
      className: "ps-4",
      cellClassName: "align-middle",
      style: { minWidth: "120px" },
      render: (item) => (
        <div className="fs-12">
          <div className="fw-medium text-black">{item.displayDate}</div>
          <div className="text-muted">{item.time}</div>
        </div>
      ),
    },
    {
      label: "Transaction ID",
      key: "transactionId",
      cellClassName: "align-middle",
      style: { minWidth: "140px" },
      render: (item) => (
        <span className="fw-medium text-black fs-13">{item.transactionId}</span>
      ),
    },
    {
      label: "Bulk ID",
      key: "bulkId",
      cellClassName: "align-middle",
      style: { minWidth: "100px" },
      render: (item) => (
        <span className="fw-medium text-black fs-13">{item.bulkId}</span>
      ),
    },
    {
      label: "Sender Name",
      key: "senderName",
      cellClassName: "align-middle",
      style: { minWidth: "140px" },
      render: (item) => (
        <div className="fs-12">
          <div className="fw-medium text-black">{item.senderName}</div>
          <div className="text-muted">{item.senderType}</div>
        </div>
      ),
    },
    {
      label: "Send Amount",
      key: "sendAmount",
      cellClassName: "align-middle",
      style: { minWidth: "130px" },
      render: (item) => (
        <span className="fw-medium text-black fs-13">{item.sendAmount}</span>
      ),
    },
    {
      label: "Receiving method",
      key: "receivingMethod",
      cellClassName: "align-middle",
      style: { minWidth: "160px" },
      render: (item) => (
        <span className="fw-medium text-black fs-13">
          {item.receivingMethod}
        </span>
      ),
    },
    {
      label: "Payment Method",
      key: "paymentMethod",
      cellClassName: "align-middle",
      style: { minWidth: "150px" },
      render: (item) => (
        <span className="fw-medium text-black fs-13">{item.paymentMethod}</span>
      ),
    },
    {
      label: "Status",
      key: "status",
      cellClassName: "align-middle",
      style: { minWidth: "120px" },
      render: (item) => {
        let color = "#667085"; // default Gray
        let bgColor = "#F8F9FA";
        let borderColor = "#EAECF0";

        if (item.statusValue === "refunding") {
          color = "#B42318";
          bgColor = "#FEF3F2";
          borderColor = "#FECDCA";
        }

        return (
          <Badge
            bg="light"
            className="px-3 py-1 border rounded"
            style={{
              fontSize: "11px",
              color: color,
              backgroundColor: bgColor,
              borderColor: borderColor,
            }}
          >
            {item.status}
          </Badge>
        );
      },
    },
    {
      label: "Actions",
      key: "actions",
      className: "pe-4 text-center",
      cellClassName: "align-middle",
      style: { minWidth: "80px" },
      render: (item) => (
        <button
          className="btn btn-xs p-0 border-0 bg-transparent text-muted"
          onClick={() => {
            setSelectedRefund(item);
            setShowViewModal(true);
          }}
        >
          <i className="far fa-eye fs-14"></i>
        </button>
      ),
    },
  ];

  const paymentMethodOptions = [
    { label: "Cash", value: "cash" },
    { label: "Bank Transfer", value: "bank_transfer" },
  ];

  const receivingMethodOptions = [
    { label: "Bank Transfer", value: "bank_transfer" },
    { label: "Cash", value: "cash" },
  ];

  return (
    <div className="container-fluid">
      <div className="mb-4">
        <h2 className="fw-bold text-black mb-4 fs-24">Refunds</h2>
        <div className="card mb-4" style={{ borderRadius: "10px" }}>
          <div className="card-body p-3">
            <Row className="g-2 align-items-center">
              <Col xl={2} lg={3} md={6}>
                <CommonInput
                  type="text"
                  placeholder="Enter transaction ID"
                  value={filters.transactionId}
                  onChange={(e) =>
                    handleFilterChange("transactionId", e.target.value)
                  }
                />
              </Col>
              <Col xl={2} lg={3} md={6}>
                <CommonInput
                  type="text"
                  placeholder="Enter bulk ID"
                  value={filters.bulkId}
                  onChange={(e) => handleFilterChange("bulkId", e.target.value)}
                />
              </Col>
              <Col xl={2} lg={3} md={6}>
                <CommonSelect
                  placeholder="Select payment method"
                  options={paymentMethodOptions}
                  value={filters.paymentMethod}
                  onChange={(val) => handleFilterChange("paymentMethod", val)}
                />
              </Col>
              <Col xl={2} lg={3} md={6}>
                <CommonSelect
                  placeholder="Select receiving method"
                  options={receivingMethodOptions}
                  value={filters.receivingMethod}
                  onChange={(val) => handleFilterChange("receivingMethod", val)}
                />
              </Col>
              <Col md="auto" className="d-flex gap-2">
                <CommonButton
                  onClick={handleReset}
                  variant="outline"
                  className="px-3"
                >
                  <i className="flaticon-381-repeat-1"></i>
                </CommonButton>
                <CommonButton onClick={handleSearch} className="px-3">
                  <i className="flaticon-381-search-1 fs-18 text-white"></i>
                </CommonButton>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
        <div className="card-body">
          <DataTable
            columns={columns}
            data={displayData}
            showPagination={false}
            minWidth="100%"
          />
        </div>
      </div>

      <RefundInformationModal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        refund={selectedRefund}
      />
    </div>
  );
};

export default RefundsList;
